import type { JSX } from "react";
import { AccountDeletionPage } from "./AccountDeletionPage.js";
import { DisclosuresPage } from "./DisclosuresPage.js";
import type { LegalPageKey } from "./paths.js";
import { PrivacyPage } from "./PrivacyPage.js";
import { SupportPage } from "./SupportPage.js";
import { TermsPage } from "./TermsPage.js";

const PAGES: Record<LegalPageKey, () => JSX.Element> = {
  terms: TermsPage,
  privacy: PrivacyPage,
  disclosures: DisclosuresPage,
  support: SupportPage,
  accountDeletion: AccountDeletionPage,
};

/** The legal page a route names. */
export function LegalPageView({ page }: { readonly page: LegalPageKey }) {
  const Page = PAGES[page];
  return <Page />;
}
